module.exports = __webpack_public_path__ + "img/layout-1.1bd6b52f.jpg";